import {Injectable} from '@angular/core';

import {AppState} from '../app-state';

import {HttpClient} from "@angular/common/http";
import {AppConfig} from "../../../environments/environment";
import {RestClient} from "./rest-client";
import {Market} from "../models/market";

@Injectable({providedIn: 'root'})
export class MarketService extends RestClient<Market> {
    private timezones = [
        {
            "name": "America/New_York",
            "description": "EST",
        },
        {
            "name": "America/Denver",
            "description": "MST",
        },
        {
            "name": "America/Chicago",
            "description": "CST",
        },
        {
            "name": "America/Cuiaba",
            "description": "AST",
        },
        {
            "name": "America/Los_Angeles",
            "description": "PST",
        },
    ]


    constructor(http: HttpClient, appState: AppState) {
        super(http, 'market', appState)
    }

    getMarkets() {
        return this.http.get(AppConfig.apiUrl + '/market/')
    }

    deleteMarket(name: string) {
        return this.http.delete(AppConfig.apiUrl + `/market/${name}`)
    }

    createUpdateMarket(market: Market, name: string = '', edit_mode) {
        if (edit_mode) {
            return this.http.patch(AppConfig.apiUrl + `/market/${name}`, {market: market})
        } else {
            return this.http.post(AppConfig.apiUrl + `/market`, {market: market})
        }
    }

    getTimeZones() {
        return this.timezones;
    }

    getSingleTimezoneText(timezone: string) {
        return this.timezones.filter((single_timezone) => single_timezone.name == timezone)[0].description
    }
}